export default __webpack_public_path__ + "static/media/promo4.aed805b1.webp";